module.exports = "https://dev.stanwinstonschool.com/1-story-mobile.9d4cc381bcb6539667bf834a5aac4b2a.jpg";